<template>
  <div class="toastification">
    <div class="d-flex align-items-start">
<!--      <feather-icon-->
<!--          icon="BellIcon"-->
<!--          size="15"-->
<!--      />-->
<!--      <i class="las la-file scale5 mr-3"></i>-->
<!--      <i class="fas fa-bell"></i>-->
<!--      <i  data-feather="file-text"></i>-->
<!--      <div class="position-relative d-inline-block">-->
<!--        <BIconExclamationCircle />-->
<!--        <span class="badge badge-pill badge-danger badge-glow badge-up">1</span>-->
<!--      </div>-->
<!--      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-left-circle-fill" viewBox="0 0 16 16">-->
<!--        <path d="M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0zm-5.904-2.803a.5.5 0 1 1 .707.707L6.707 10h2.768a.5.5 0 0 1 0 1H5.5a.5.5 0 0 1-.5-.5V6.525a.5.5 0 0 1 1 0v2.768l4.096-4.096z"/>-->
<!--      </svg>-->
      <div class="d-flex flex-grow-1">
        <div>
          <h5
              v-if="title"
              class="mb-0 font-weight-bolder toastification-title"
              :class="`text-${variant}`"
              v-text="title"
          />
          <small
              v-if="text"
              class="d-inline-block text-body"
              v-text="text"
          />
        </div>
        <span
            class="cursor-pointer toastification-close-icon ml-auto "
            @click="$emit('close-toast')"
        >
          <feather-icon
              v-if="!hideClose"
              icon="XIcon"
              class="text-body"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// import { BAvatar } from 'bootstrap-vue'

export default {
  // components: {
  //   BAvatar,
  // },
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    hideClose: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style  scoped>
.toastification-close-icon,
.toastification-title {
  line-height: 26px;
}

.toastification-title {
  color: inherit;
}
</style>
